import React, { useEffect } from 'react';
import { Alert, InputGroupText } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Form, Field } from '@availity/form';
import * as yup from 'yup';
import '@availity/yup';
import * as authActions from '../../store/auth/actions';
import AuthShell from '../../components/Common/AuthShell';

const Register = () => {
  const error = useSelector((state) => state.Auth.error);
  const success = useSelector((state) => state.Auth.success);
  const loading = useSelector((state) => state.Auth.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.resetMessages());
  }, []);

  const handleValidSubmit = ({ email, password, displayName }) => {
    dispatch(authActions.registerWithEmail(email, password, displayName));
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle="A few seconds and your agents and your team work in one place."
      footer={
        <p className="mb-0">
          Already have an account?{' '}
          <Link to="/login" className="font-weight-medium text-primary">
            Sign in
          </Link>
        </p>
      }>
      {error !== '' && <Alert color="danger">{error}</Alert>}
      {success !== '' && <Alert color="success">{success}</Alert>}
      <Form
        initialValues={{
          email: '',
          displayName: '',
          password: '',
        }}
        onSubmit={handleValidSubmit}
        validationSchema={yup.object().shape({
          email: yup.string().email().required(),
          displayName: yup.string().required().min(5),
          password: yup.string().required(),
        })}>
        <Field
          name="email"
          label="Email"
          type="email"
          placeholder="Enter email"
          prepend={
            <InputGroupText>
              <i className="bx bx-envelope"></i>
            </InputGroupText>
          }
        />
        <Field
          name="displayName"
          label="Display Name"
          type="text"
          placeholder="Enter display name"
          prepend={
            <InputGroupText>
              <i className="bx bx-user"></i>
            </InputGroupText>
          }
        />
        <Field
          name="password"
          label="Password"
          type="password"
          placeholder="Enter Password"
          prepend={
            <InputGroupText>
              <i className="bx bx-lock-alt"></i>
            </InputGroupText>
          }
        />
        <button
          className="btn btn-primary btn-block waves-effect waves-light mt-3 py-2"
          type="submit"
          disabled={loading}>
          <i
            className={`bx ${
              loading ? 'bx-loader bx-spin' : 'bx-user-plus'
            } font-size-16 align-middle mr-2`}></i>
          Register
        </button>
        <p className="text-muted text-center font-size-12 mt-3 mb-0">
          By registering you agree to the Lead1{' '}
          <Link to="#" className="text-primary">
            Terms of Use
          </Link>
        </p>
      </Form>
    </AuthShell>
  );
};

export default withRouter(Register);
